import nocSoc from "public/network-services/noc-soc-helpdesk.png";

export const INTRO_CONSTANTS = {
  title: "Integrated NOC, SOC & IT Helpdesk Services",
  description: [
    "OneMind delivers a fully managed suite of Network Operations Center (NOC), Security Operations Center (SOC), and IT Helpdesk services—designed to keep your infrastructure running smoothly, securely, and without disruption.",
    "NOC : Proactive monitoring and management to maintain network health, performance, and availability.",
    "SOC : Continuous threat detection, analysis, and response to safeguard your environment against evolving cyber risks.",
    "IT Helpdesk : Responsive technical support for end-users, resolving issues quickly and minimizing downtime.",
    "Together, these services strengthen your organization’s IT resilience—reducing risk, increasing uptime, and supporting seamless day-to-day operations.",
  ],
  image: nocSoc,
  imageHeight: "340px",
};
